var React = require('react');

function IconPlayButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M34.5 0C53.554 0 69 15.446 69 34.5 69 53.554 53.554 69 34.5 69 15.446 69 0 53.554 0 34.5 0 15.446 15.446 0 34.5 0zM25 19v31l27-15.5L25 19z","fill":"#FFF","fillRule":"evenodd"}));
}

IconPlayButton.displayName = "IconPlayButton";

IconPlayButton.defaultProps = {"width":"69","height":"69"};

module.exports = IconPlayButton;

IconPlayButton.default = IconPlayButton;
